import ColumnBase from "./ColumnBase.jsx";
import { WIDGET_KEYS } from "../../other/constants/WidgetKeys.jsx";
import { ColumnStore, MessageDialog } from "@bryntum/schedulerpro";
import { EntityMainNameDefault, getCustomGroupRenderer, getRolesWithoutPublic } from "../../other/utils/utils.jsx";

export default class UserRoleColumn extends ColumnBase {
  static get $name() {
    return "UserRoleColumn"
  }

  static get type() {
    return WIDGET_KEYS.userRoleColumn;
  }

  static get defaults() {
    return {
      text: "Role",
      field: "roles",
      sortable(record1, record2) {
        return record1.roles < record2.roles ? -1: 1;
      },
      editor: false,
      flex: 1,
    }
  }

  renderer({ record }) {
    if (!record.isGroupHeader) {
      return EntityMainNameDefault({ text: record.roleName })
    }
  }

  groupRenderer(e) {
    return getCustomGroupRenderer(e);
  }

  onLoad(project, { user }) {
    this.project = project;
    this.user = user;
  }

  get canEmptySwivuList() {
    return false;
  }

  get swivuListTitle() {
    return "Role"
  }

  get swivuListItems() {
    return getRolesWithoutPublic(this.project.swivuAppRoles);
  }

  getSwivuListItemDisplayValue(roleRecord) {
    return `<span>${roleRecord.name}</span>`;
  }

  getSelectedSwivuListItem(record) {
    return this.swivuListItems.find((role) => role.id === record.roles);
  }

  onSwivuBeforeListSelectionChange(record) {
    const currentBoard = this.project.boardStore.find((board) => board.id === record.board);
    if (!record.email) {
      MessageDialog.alert({ title: "Cannot Update Role", message: "Please enter your email address!" });
      return false;
    } else if (record.userId === this.user.id) {
      MessageDialog.alert({ title: "Cannot Update Role", message: "You cannot change your own role!" });
      return false
    } else if (record.id === currentBoard.owner) {
      MessageDialog.alert({ title: "Cannot Update Role", message: "You cannot change the role of the board owner!" });
      return false;
    }
    return true;
  }

  onSwivuListSelectionChange(record, [roleRecord]) {
    record.roles = roleRecord.id;
    this.grid.features.rowExpander.collapse(record);
  }
}

ColumnStore.registerColumnType(UserRoleColumn);
